<template>
  <v-col cols="12" class="pa-3">
    <v-row>
      <v-col cols="12" lg="9">
        <v-row class="pt-8" align="center" justify="space-around">
          <router-link to="/contact/customers" v-slot="{ href, navigate, isActive }">
            <a :href="href" @click="navigate">
              <v-btn
                rounded
                class="rounded-tr-0 px-8 text-white"
                :outlined="!isActive"
                :color="isActive ? 'IMThemeOrange' : 'IMThemeGray'"
              >
                <img
                  src="/media/svg/btn/customer.svg"
                  :class="{ 'filter-dark': !isActive }"
                  width="24"
                  class="ml-3"
                />
                مستفيدون
              </v-btn>
            </a>
          </router-link>
          <router-link to="/contact/store-order" v-slot="{ href, navigate, isActive }">
            <a :href="href" @click="navigate">
              <v-badge v-if="!isRead" right overlap color="red">
                <v-btn
                  rounded
                  class="rounded-tr-0 px-8 text-white"
                  :outlined="!isActive"
                  :color="isActive ? 'IMThemeOrange' : 'IMThemeGray'"
                >
                  <img
                    src="/media/svg/btn/shop.svg"
                    :class="{ 'filter-dark': !isActive }"
                    width="24"
                    class="ml-3"
                  />
                  مشتركون
                </v-btn>
              </v-badge>
              <v-btn
                v-else
                rounded
                class="rounded-tr-0 px-8 text-white"
                :outlined="!isActive"
                :color="isActive ? 'IMThemeOrange' : 'IMThemeGray'"
              >
                <img
                  src="/media/svg/btn/shop.svg"
                  :class="{ 'filter-dark': !isActive }"
                  alt="store icon"
                  width="24"
                  class="ml-3"
                />
                مشتركون
              </v-btn>
            </a>
          </router-link>
        </v-row>
        <v-col cols="12" class="pt-8">
          <router-view name="table"></router-view>
        </v-col>
      </v-col>
      <v-col cols="12" lg="3">
        <div class="mx-auto" style="max-width: 400px">
          <!-- <img
            src="/media/svg/victors/order-actions.svg"
            alt="vector image"
            class="w-100"
          /> -->
          <div class="pt-16">
            <router-view
              name="actions"
              v-if="customersIndex != undefined || orderIndex != undefined"
            ></router-view>
            <h5 v-else>يرجى تحديد سطر لعرض التفاصيل</h5>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-col>
</template>
<style scoped>
.filter-dark {
  filter: invert(100%) saturate(0%) brightness(159%) contrast(109%);
}
</style>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    orderIndex: String,
    customersIndex: String,
  },
  created() {
    this.CheckIfOrderRead();
    this.setBreadcrumbs([
      {
        text: "تواصل معنا",
      },
    ]);
  },
  computed: {
    ...mapGetters(["isRead"]),
  },
  methods: {
    ...mapActions(["setBreadcrumbs", "CheckIfOrderRead"]),
  },
};
</script>
